import { makeStyles } from '@material-ui/core';

import { colors } from '../../../assets';

export const useStyles = makeStyles(() => ({
  checkAdornment: {
    color: colors.functionals.success,
    marginRight: 16,
    marginBottom: 12,
  },
}));
